import React, { useState, useEffect } from "react";
import LogoImg from "../../assets/images/logonew.png";
import TeamImg from "../../assets/images/team.png";
import { ToastContainer, toast, Bounce } from "react-toastify";
import api from "../../setupMiddleware";
import Popup from "../Common/Popup";
import { useLocation } from "react-router-dom";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";

const ResetPassword = () => {
  const location = useLocation();
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [conPassword, setConPassword] = useState("");
  const [open, setOpen] = useState(false);
  const [passwordError, setpasswordError] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);

  const handleClickShowPassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const [emailError, setEmailError] = useState(false);

  const sendResendLink = async () => {
    if (!email) {
      setEmailError(true);
      toast.error("Please enter Email!", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      return;
    } else {
      try {
        await api
          .post("/api/reset-password", {
            email,
            token,
            password,
            password_confirmation: conPassword,
          })
          .then((res) => {
            if (res && res.status === 200) {
              toast.success(res.data?.message, {
                position: "top-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
              });
              setTimeout(() => {
                window.location = "/";
              }, 1500);
            }
          });
      } catch (error) {
        if (error) {
          toast.warning(error.response?.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
        }
      }
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenParam = queryParams.get("token");
    const emailParam = queryParams.get("email");

    if (tokenParam) setToken(tokenParam);
    if (emailParam) setEmail(emailParam);
  }, [location.search]);

  return (
    <div className="relative rounded-[20px] bg-[#f9f9f9] min-h-screen py-[40px]">
      <div className="max-w-[1340px] min-h-[calc(100vh-80px)] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[30%_60%] items-stretch justify-between px-8 m-auto gap-">
        {/* Left Section (1/3, form centered, footer bottom) */}
        <div className="flex flex-col justify-between items-center md:items-start px-5 py-8">
          {/* Centered Form Content */}
          <div className="flex w-full flex-col justify-center items-center md:items-start flex-grow">
            <div className="block w-full">
              {/* Logo & Title */}
              <div className="flex flex-col items-center md:items-start gap-2.5">
                <img
                  src={LogoImg}
                  className="w-[234px] h-[76px] object-cover"
                  alt="logo"
                />
                <p className="text-xl text-center md:text-left capitalize text-[#142b70]">
                  Reset Password
                </p>
              </div>

              {/* Form Fields */}
              <div className="flex flex-col w-full gap-5 mt-12 mb-12">
                {/* Email */}
                <div className="flex flex-col gap-2.5">
                  <p className="text-xs text-[#142b70]">Email</p>
                  <input
                    className={`w-full h-[54px] p-2.5 rounded-xl bg-white border-2
                     border-[#ddd] ${
                       emailError ? "border-[#880000]" : ""
                     } focus:border-[#edc9b7] focus:outline-none shadow-[0px_44px_92px_0_rgba(159,159,159,0.25)] 
                     disabled:text-gray-400 disabled:pointer-events-none disabled:cursor-not-allowed`}
                    type="text"
                    name="username"
                    disabled
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                {/* Password */}
                <div className="flex flex-col gap-2.5 mb-2">
                  <p className="text-xs text-[#142b70]">Password</p>
                  <div className="relative">
                    <input
                      className={`w-full h-[54px] p-2.5 rounded-xl bg-white border-2 border-[#ddd] ${
                        passwordError ? "border-[#880000]" : ""
                      } focus:border-[#edc9b7] focus:outline-none shadow-[0px_44px_92px_0_rgba(159,159,159,0.25)]`}
                      type={passwordShown ? "text" : "password"}
                      name="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <div
                      className="absolute right-4 top-5 cursor-pointer"
                      onClick={handleClickShowPassword}
                    >
                      {passwordShown ? (
                        <FiEye color="#142b70" />
                      ) : (
                        <FiEyeOff color="#142b70" />
                      )}
                    </div>
                  </div>
                </div>

                {/* Confirm Password */}
                <div className="flex flex-col gap-2.5 mb-2">
                  <p className="text-xs text-[#142b70]">Confirm Password</p>
                  <div className="relative">
                    <input
                      className={`w-full h-[54px] p-2.5 rounded-xl bg-white border-2 border-[#ddd] ${
                        passwordError ? "border-[#880000]" : ""
                      } focus:border-[#edc9b7] focus:outline-none shadow-[0px_44px_92px_0_rgba(159,159,159,0.25)]`}
                      type={passwordShown ? "text" : "password"}
                      name="password"
                      value={conPassword}
                      onChange={(e) => setConPassword(e.target.value)}
                    />
                    <div
                      className="absolute right-4 top-5 cursor-pointer"
                      onClick={handleClickShowPassword}
                    >
                      {passwordShown ? (
                        <FiEye color="#142b70" />
                      ) : (
                        <FiEyeOff color="#142b70" />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Button */}
              <button
                className="w-full h-[53px] flex justify-center items-center px-[70px] py-3.5 rounded-md bg-[#de2b26] text-base font-medium text-white"
                onClick={sendResendLink}
              >
                Reset Password
              </button>
            </div>
          </div>
          {/* Footer at bottom */}
          <p className="mt-8 text-sm text-center md:text-left text-[#142b70]">
            © {new Date().getFullYear()} Money Maestro. All Rights Reserved.
          </p>
        </div>

        {/* Right Section (2/3, full height) */}
        <div className="hidden sm:flex bg-[#142b70] relative rounded-[40px] overflow-hidden justify-center items-center">
          <img src={TeamImg} alt="Team" className="w-full absolute bottom-0" />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ResetPassword;
